module.exports = __webpack_public_path__ + "static/media/logo.cfc57d7a.svg";